import { DBCollection } from '@/lib/utils/constants-shared';
import type { Firestore } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch historical events by passage from DB (Storage first, then Firestore)
 */
export async function fetchHistoricalEventsByPassageFromDB(
  auth: any,
  db: Firestore,
  storage?: FirebaseStorage
): Promise<HistoricalEventsByPassage[]> {
  const fallback = async () => {
    const historicalEventsByPassageRef = collection(db, DBCollection.historicalEventsByPassage);
    const snapshot = await getDocs(historicalEventsByPassageRef);

    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      dateCreated: doc.data().dateCreated?.toDate(),
      dateUpdated: doc.data().dateUpdated?.toDate()
    })) as HistoricalEventsByPassage[];
  };

  if (storage) {
    return await fetchCollectionFromStorage<HistoricalEventsByPassage>(
      storage,
      `bulk-data/${DBCollection.historicalEventsByPassage}.json`,
      fallback
    );
  }

  return await fallback();
}

